import React from "react";
import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import { UserProduct } from "@/types";
import QuantityPresetSelector from "@/components/shopping/edit-item/QuantityPresetSelector"; 

interface SelectedProductCardProps {
  product: UserProduct;
  quantity: string;
  setQuantity: (val: string) => void;
  unit: string;
  quantityPresets?: string[];
  categoryLabel?: string;
  onReset: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  // Callback per tornare all'elenco articoli (click su "Cambia")
  onChange: (updatedProduct?: UserProduct) => void;
  
  // Callback per "Aggiungi"
  onAdd: () => void;

  // Callback per "Aggiungi e Chiudi"
  onAddClose: () => void;
  
  // Prop per stilizzazione
  style?: React.CSSProperties;
}

const SelectedProductCard = ({
  product,
  quantity,
  setQuantity,
  unit,
  quantityPresets = [],
  categoryLabel,
  onChange,
  onAdd,
  onAddClose,
  style
}: SelectedProductCardProps) => {
  const { theme } = useThemeConfig();
  return (
    <div className="border p-3 rounded-md" style={style}>
      {/* Header con nome e pulsante "Cambia" */}
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-lg font-semibold">
          {product.name}{" "}
          <span className="text-sm">({unit})</span>
        </h2>
        <Button variant="outline" onClick={() => onChange()}
              style={{
                backgroundColor: theme.backgroundColor,                
                color: theme.textColor,                
                borderRadius: theme.buttonBorderRadius,
                padding: theme.buttonPadding,
                fontWeight: theme.buttonFontWeight,
                transitionDuration: theme.transitionSpeed,
                '--btn-bg-hover': theme.primaryColor,
              } as React.CSSProperties}
          >
          Cambia
        </Button>
      </div>

      {/* Campo quantità */}
      <div className="mb-2">
        <label className="block text-sm font-medium">Quantità</label>
        <input
          type="text"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          className="border w-full rounded p-1 text-sm"
          data-keyboard-scroll
          style={{
            backgroundColor: theme.backgroundColor,
            color: theme.primaryColor,
          } as React.CSSProperties}

        />
      </div>

      {/* Preset di quantità sotto il campo */}
      {quantityPresets.length > 0 && (
        <div className="mb-2">
          <QuantityPresetSelector
            presets={quantityPresets}
            selectedValue={quantity}
            onSelect={(val) => setQuantity(val)}
          />
        </div>
      )}

      {/* Pulsanti Aggiungi e Aggiungi e Chiudi sulla stessa riga */}
      <div className="flex justify-center gap-2 mt-2">
        <Button
          className="hover:bg-[var(--btn-bg-hover)]"
          onClick={onAdd}
          style={{
            backgroundColor: theme.primaryColor,
            color: theme.textPrimaryColor,
            fontWeight: 'bold',
            '--btn-bg-hover': theme.primaryColor,
          } as React.CSSProperties}
        >
          Aggiungi
        </Button>
        <Button
          className="hover:bg-[var(--btn-bg-hover)]"
          onClick={onAddClose}
          style={{
            backgroundColor: theme.primaryColor,
            color: theme.textPrimaryColor,
            fontWeight: 'bold',
            '--btn-bg-hover': theme.primaryColor,
          } as React.CSSProperties}
        >
          Aggiungi e Chiudi
        </Button>
      </div>
    </div>
  );
};

export default SelectedProductCard;
